import { render, staticRenderFns } from "./DialogFeedBack.vue?vue&type=template&id=5c960f9b&scoped=true&"
import script from "./DialogFeedBack.vue?vue&type=script&lang=js&"
export * from "./DialogFeedBack.vue?vue&type=script&lang=js&"
import style0 from "./DialogFeedBack.vue?vue&type=style&index=0&id=5c960f9b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c960f9b",
  null
  
)

export default component.exports